import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';
import { tr } from '../til';


const inputStyle = {
  padding: '10px 12px',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '14px'
};

const smallBtn = {
  padding: '6px 12px',
  background: '#eef1f7',
  color: '#1a1a2e',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '12px',
  cursor: 'pointer'
};

const emptyForm = () => ({
  time: '09:00',
  title: '',
  body: '',
  // Ilovaga joylangan ovoz sukut bo'yicha ishlatiladi.
  sound: 'bildirishnoma',
  is_active: true
});

function ReminderForm({ form, setForm, sounds }) {
  const set = (field, value) => setForm({ ...form, [field]: value });

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '160px 1fr', gap: '12px' }}>
      <input
        type="time"
        value={form.time}
        onChange={e => set('time', e.target.value)}
        style={inputStyle}
      />
      <input
        type="text"
        placeholder={tr("Sarlavha * (masalan: Kunlik eslatma)")}
        value={form.title}
        onChange={e => set('title', e.target.value)}
        style={inputStyle}
      />
      <select
        value={form.sound}
        onChange={e => set('sound', e.target.value)}
        style={inputStyle}
      >
        {sounds.map(s => <option key={s} value={s}>{tr("Ovoz: {s}", { s })}</option>)}
        <option value="">{tr("Ovoz: telefon standarti")}</option>
      </select>
      <input
        type="text"
        placeholder={tr("Bildirishnoma matni *")}
        value={form.body}
        onChange={e => set('body', e.target.value)}
        style={inputStyle}
      />
      <label style={{ gridColumn: '1 / -1', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#555' }}>
        <input
          type="checkbox"
          checked={form.is_active}
          onChange={e => set('is_active', e.target.checked)}
        />
        {tr("Faol (o'chirilsa xodimlarga bormaydi)")}
      </label>
    </div>
  );
}

function Reminders() {
  const [reminders, setReminders] = useState([]);
  const [sounds, setSounds] = useState([]);
  const [form, setForm] = useState(emptyForm());
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [saving, setSaving] = useState(false);

  const [editing, setEditing] = useState(null);
  const [editError, setEditError] = useState('');

  const token = localStorage.getItem('token');

  const load = useCallback(async () => {
    const [remindersRes, soundsRes] = await Promise.all([
      axios.get(`${API}/reminders`, { headers: { authorization: token } }),
      axios.get(`${API}/reminders/sounds`, { headers: { authorization: token } })
    ]);
    setReminders(remindersRes.data);
    setSounds(soundsRes.data.sounds || []);
  }, [token]);

  useEffect(() => {
    load();
  }, [load]);

  const validate = (f) => {
    if (!f.time) return tr("Vaqtni tanlang");
    if (!f.title.trim()) return tr("Sarlavha kiriting");
    if (!f.body.trim()) return tr("Bildirishnoma matnini kiriting");
    return null;
  };

  const create = async () => {
    setError('');
    setSuccess('');

    const invalid = validate(form);
    if (invalid) { setError(invalid); return; }

    setSaving(true);
    try {
      await axios.post(`${API}/reminders/create`, form, {
        headers: { authorization: token }
      });
      setSuccess(tr("{time} uchun eslatma qo'shildi.", { time: form.time }));
      setForm(emptyForm());
      load();
    } catch (err) {
      setError(err.response?.data?.error || tr("Eslatma qo'shilmadi."));
    } finally {
      setSaving(false);
    }
  };

  const saveEdit = async () => {
    setEditError('');
    const invalid = validate(editing);
    if (invalid) { setEditError(invalid); return; }

    try {
      await axios.put(`${API}/reminders/${editing.id}`, editing, {
        headers: { authorization: token }
      });
      setSuccess(tr("Eslatma yangilandi."));
      setEditing(null);
      load();
    } catch (err) {
      setEditError(err.response?.data?.error || tr("Saqlanmadi."));
    }
  };

  const toggleActive = async (r) => {
    setError('');
    setSuccess('');
    try {
      await axios.put(`${API}/reminders/${r.id}`, { ...r, is_active: !r.is_active }, {
        headers: { authorization: token }
      });
      load();
    } catch (err) {
      setError(err.response?.data?.error || tr("Amal bajarilmadi."));
    }
  };

  const remove = async (r) => {
    setError('');
    setSuccess('');
    if (!window.confirm(tr("{time} — \"{title}\" eslatmasi o'chirilsinmi?", { time: r.time, title: r.title }))) return;

    try {
      await axios.delete(`${API}/reminders/${r.id}`, { headers: { authorization: token } });
      setSuccess(tr("Eslatma o'chirildi."));
      load();
    } catch (err) {
      setError(err.response?.data?.error || tr("O'chirib bo'lmadi."));
    }
  };

  const activeCount = reminders.filter(r => r.is_active).length;

  return (
    <div>
      <h2 style={{ marginBottom: '8px', fontSize: '22px' }}>{tr("Kunlik eslatmalar")}</h2>
      <p style={{ marginTop: 0, marginBottom: '24px', color: '#888', fontSize: '14px' }}>
        {tr("Belgilangan vaqtlarda xodimlar telefoniga bildirishnoma boradi. Hozir")} <strong>{tr("{activeCount} ta", { activeCount })}</strong> {tr("faol eslatma bor.")}
      </p>

      <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 8px rgba(0,0,0,0.06)', marginBottom: '24px' }}>
        <h3 style={{ marginBottom: '16px', fontSize: '16px' }}>{tr("Yangi eslatma")}</h3>

        <ReminderForm form={form} setForm={setForm} sounds={sounds} />

        {error && (
          <div style={{ background: '#ffeaea', color: '#c93636', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', margin: '12px 0' }}>
            {error}
          </div>
        )}
        {success && (
          <div style={{ background: '#e9f9ed', color: '#2d8a2d', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', margin: '12px 0' }}>
            {success}
          </div>
        )}

        <button
          onClick={create}
          disabled={saving}
          style={{
            marginTop: '12px',
            padding: '10px 24px',
            background: saving ? '#888' : '#1a1a2e',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            width: '100%',
            cursor: saving ? 'default' : 'pointer'
          }}
        >
          {saving ? tr("Qo'shilmoqda...") : tr("Qo'shish")}
        </button>
      </div>

      <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 8px rgba(0,0,0,0.06)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
              <th style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500', width: '80px' }}>{tr("Vaqt")}</th>
              <th style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Sarlavha va matn")}</th>
              <th style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Ovoz")}</th>
              <th style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Holat")}</th>
              <th style={{ textAlign: 'right', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Amallar")}</th>
            </tr>
          </thead>
          <tbody>
            {reminders.map(r => (
              <tr key={r.id} style={{ borderBottom: '1px solid #f9f9f9', opacity: r.is_active ? 1 : 0.5 }}>
                <td style={{ padding: '10px 8px', fontWeight: '600', fontSize: '16px', color: '#1a1a2e' }}>
                  {r.time}
                </td>
                <td style={{ padding: '10px 8px' }}>
                  <div style={{ fontWeight: '500' }}>{r.title}</div>
                  <div style={{ color: '#999', fontSize: '12px', marginTop: '2px' }}>{r.body}</div>
                </td>
                <td style={{ padding: '10px 8px', color: '#888', fontSize: '13px' }}>
                  {r.sound || tr("standart")}
                </td>
                <td style={{ padding: '10px 8px' }}>
                  <span style={{
                    background: r.is_active ? '#e9f9ed' : '#f0f0f0',
                    color: r.is_active ? '#2d8a2d' : '#999',
                    padding: '3px 10px',
                    borderRadius: '20px',
                    fontSize: '12px'
                  }}>
                    {r.is_active ? tr("Faol") : tr("O'chiq")}
                  </span>
                </td>
                <td style={{ padding: '10px 8px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                  <button
                    onClick={() => { setEditError(''); setEditing({ ...r }); }}
                    style={{ ...smallBtn, marginRight: '6px' }}
                  >
                    {tr("Tahrirlash")}
                  </button>
                  <button
                    onClick={() => toggleActive(r)}
                    style={{ ...smallBtn, marginRight: '6px', color: r.is_active ? '#c93636' : '#2d8a2d' }}
                  >
                    {r.is_active ? tr("O'chirish") : tr("Yoqish")}
                  </button>
                  <button onClick={() => remove(r)} style={{ ...smallBtn, color: '#c93636' }}>
                    ✕
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {reminders.length === 0 && (
          <p style={{ color: '#999', fontSize: '14px', textAlign: 'center', margin: '20px 0 0' }}>
            {tr("Hali eslatma qo'shilmagan.")}
          </p>
        )}
      </div>

      <p style={{ color: '#999', fontSize: '12px', marginTop: '16px', lineHeight: '1.6' }}>
        {tr("Eslatmalar xodim telefonining o'zida rejalashtiriladi — internet bo'lmasa ham keladi. Vaqtni o'zgartirsangiz, xodim ilovani keyingi ochganda yangi jadval qo'llanadi.")}
      </p>

      {editing && (
        <div
          onClick={() => setEditing(null)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', zIndex: 100
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: '12px', padding: '24px', width: '100%', maxWidth: '600px' }}
          >
            <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '18px' }}>{tr("Eslatmani tahrirlash")}</h3>

            <ReminderForm form={editing} setForm={setEditing} sounds={sounds} />

            {editError && (
              <div style={{ background: '#ffeaea', color: '#c93636', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginTop: '12px' }}>
                {editError}
              </div>
            )}

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
              <button onClick={() => setEditing(null)} style={{ ...smallBtn, padding: '10px 20px', fontSize: '14px' }}>
                {tr("Bekor qilish")}
              </button>
              <button
                onClick={saveEdit}
                style={{
                  padding: '10px 24px',
                  background: '#1a1a2e',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '14px',
                  cursor: 'pointer'
                }}
              >
                {tr("Saqlash")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Reminders;
